import { Component, Input } from '@angular/core';
import { AssignmentCustomerResponse, BaseAvatarSize, CustomerAssignmentListItemResponse } from 'base';

@Component({
  selector: 'base-customer-employee-short-info',
  templateUrl: './base-customer-external-employee-short-info.component.html',
})
export class BaseCustomerExternalEmployeeShortInfoComponent {
  @Input() currentAssignment: AssignmentCustomerResponse | CustomerAssignmentListItemResponse | undefined;
  @Input() avgRating?: number;
  @Input() ratingAmount?: number;
  avatarSize = BaseAvatarSize;

  get currentRate() {
    if (typeof this.avgRating === 'number') {
      return this.avgRating;
    }

    if (this.currentAssignment && this.isAssignmentCustomerResponse(this.currentAssignment)) {
      return this.currentAssignment.profile?.averageRating ?? 0;
    }

    return 0;
  }

  get reviewCount() {
    if (typeof this.ratingAmount === 'number') {
      return this.ratingAmount;
    }

    if (this.currentAssignment && this.isAssignmentCustomerResponse(this.currentAssignment)) {
      return this.currentAssignment.profile?.ratingCount ?? 0;
    }

    return 0;
  }

  isAssignmentCustomerResponse(
    assignment: AssignmentCustomerResponse | CustomerAssignmentListItemResponse
  ): assignment is AssignmentCustomerResponse {
    return 'contracts' in assignment;
  }
}
